import React from 'react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
}

const Checkbox = ({ checked, onChange, className = '', ...props }: CheckboxProps) => (
  <input
    type="checkbox"
    checked={checked}
    onChange={onChange}
    className={`h-4 w-4 appearance-none rounded border border-gray-300 dark:border-gray-500 bg-gray-100 dark:bg-gray-600 checked:bg-blue-600 checked:border-blue-600 dark:checked:bg-blue-600 dark:checked:border-blue-600 cursor-pointer relative checked:after:content-['\\2713'] checked:after:text-white checked:after:text-xs checked:after:absolute checked:after:inset-0 checked:after:flex checked:after:items-center checked:after:justify-center ${className}`}
    {...props}
  />
);

export default Checkbox;
